"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_redux_1 = require("react-redux");
const config_1 = require("../../../web/firebase/config");
const Hamburger_1 = __importDefault(require("../../assets/icons/Hamburger"));
const header_1 = require("../../components/header");
const ModalMenu_1 = __importDefault(require("../../components/modal/ModalMenu"));
const skeletons_1 = require("../../components/skeletons");
const Home_1 = __importDefault(require("../../networking/apis/Home"));
const scale_1 = require("../../utils/scale");
const DisconnectScreen_1 = require("../DisconnectScreen");
const ItemLoop_1 = __importDefault(require("./components/ItemLoop"));
const HomeScreen = (_props) => {
    const [visibleMenu, setVisibleMenu] = (0, react_1.useState)(false);
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [checkLoadMore, setCheckLoadMore] = (0, react_1.useState)(false);
    const [timeNow, setTimeNow] = (0, react_1.useState)();
    const [dataListArticles, setDataListArticles] = (0, react_1.useState)([]);
    const [countPageNewArticles, setCountPageNewArticles] = (0, react_1.useState)(1);
    const [countTweet, setConutTweet] = (0, react_1.useState)(1);
    const [listIdTweet, setListIdTweet] = (0, react_1.useState)([]);
    const datarRef = (0, react_1.useRef)([]);
    const [checkLoadmoreNewTweet, setCheckLoadmoreNewTweet] = (0, react_1.useState)(true);
    const [checkLoadmoreNewArticles, setCheckLoadmoreNewArticles] = (0, react_1.useState)(true);
    const [checkLoadmoreNewArticlesFollow, setCheckLoadmoreNewArticlesFollow] = (0, react_1.useState)(true);
    const [newTweet, setNewTweet] = (0, react_1.useState)([]);
    const [reloadPage, setReloadPage] = (0, react_1.useState)(false);
    const [dataCallApi, setDataCallApi] = (0, react_1.useState)();
    const [checkLoadmore, setCheckLoadmore] = (0, react_1.useState)(false);
    const userAuthFirebase = (0, react_redux_1.useSelector)((state) => state.loginFirebaseReducer.user, react_redux_1.shallowEqual);
    const connected = (0, react_redux_1.useSelector)((state) => state.appReducer.connected, react_redux_1.shallowEqual);
    const dataUser = (0, react_redux_1.useSelector)((state) => state?.loginReducer?.dataProfile, react_redux_1.shallowEqual);
    (0, react_1.useEffect)(() => {
        datarRef.current = dataListArticles;
    }, [dataListArticles]);
    (0, react_1.useEffect)(() => {
        if (listIdTweet?.length > 0) {
            if (react_native_1.Platform.OS === 'web' && userAuthFirebase) {
                const { firebase } = require('../../../web/firebase/config');
                const unsubscribe = firebase
                    .firestore()
                    .collection('tweets')
                    .where(firebase.firestore.FieldPath.documentId(), 'in', listIdTweet)
                    .onSnapshot((snapshot) => {
                    // Xử lý các thay đổi trong snapshot
                    handleSnapshotChanges(snapshot);
                });
                // Ngắt kết nối khi component unmount
                return () => {
                    unsubscribe();
                };
            }
        }
    }, [listIdTweet, !!userAuthFirebase?.uid]);
    const handleSnapshotChanges = (snapshot) => {
        // Xử lý các thay đổi trong snapshot
        snapshot.docChanges().forEach((change) => {
            const data = change.doc;
            const dataSnapshot = datarRef.current;
            if (change.type === 'added') {
            }
            if (change.type === 'modified') {
                const newData = dataSnapshot.map((item) => {
                    const newDataFirebase = item.dataFirebase.map((firebaseItem) => {
                        if (firebaseItem.id === data?.id) {
                            const dataEdit = data?.data();
                            dataEdit._id = data?.id;
                            return { ...firebaseItem, data: dataEdit };
                        }
                        return firebaseItem;
                    });
                    return { ...item, dataFirebase: newDataFirebase };
                });
                setDataListArticles(newData);
                // Xử lý khi có document được sửa đổi
            }
            if (change.type === 'removed') {
                // Xử lý khi có document bị xóa
            }
        });
    };
    (0, react_1.useEffect)(() => {
        if (timeNow) {
            if (react_native_1.Platform.OS === 'web' && userAuthFirebase) {
                const unsubscribe = config_1.firebase
                    .firestore()
                    .collection('tweets')
                    .where('createdAt', '>', timeNow)
                    .onSnapshot(async (snapshot) => {
                    let dataNewTweets = [];
                    for (let index = 0; index < snapshot.docs.length; index++) {
                        let data = snapshot.docs[index].data();
                        data._id = snapshot.docs[index].id;
                        if (data.isDeleted == 0) {
                            const blockList = await config_1.firebase
                                .firestore()
                                .collection('users')
                                .doc(data.userId.toString())
                                .collection('blockUsers')
                                .get();
                            const isBlocked = blockList.docs.some((data) => data.id == dataUser?.user_id);
                            if (isBlocked) {
                                data.isDeleted = 1;
                            }
                            ;
                        }
                        const getIndex = listIdTweet.findIndex((it) => it == data._id);
                        if (getIndex == -1) {
                            dataNewTweets.unshift(data);
                        }
                    }
                    setNewTweet(dataNewTweets);
                });
                return () => {
                    unsubscribe();
                };
            }
        }
    }, [timeNow, !!userAuthFirebase?.uid]);
    const displayTweet = (data) => {
        const newData = dataListArticles.map((item) => {
            const newDataFirebase = item.dataFirebase.filter((firebaseItem) => {
                return firebaseItem.id !== data;
            });
            return { ...item, dataFirebase: newDataFirebase };
        });
        setDataListArticles(newData);
    };
    (0, react_1.useEffect)(() => {
        if (dataUser && connected) {
            reloadScreen();
        }
    }, [dataUser?.registration_status, connected]);
    (0, react_1.useEffect)(() => {
        let data = [];
        if (reloadPage == false) {
            if (dataCallApi) {
                setCheckLoadmore(false);
                data = dataListArticles.concat(dataCallApi);
                setDataListArticles(data);
            }
        }
        else {
            if (dataCallApi) {
                data = dataCallApi;
                setDataListArticles(data);
                setReloadPage(false);
            }
        }
    }, [dataCallApi]);
    const callApiListTweet = async (page, perpage) => {
        let data = [];
        let timeOne = dataListArticles[0]?.dataFirebase[0]?.data?.createdAt;
        let time = page == 1 ? false : (0, moment_1.default)(timeOne).format('YYYY-MM-DD HH:mm:ss');
        try {
            const res = await Home_1.default.ListTweet({ page: page, perpage }, time);
            let check = listIdTweet?.length > 23 ? listIdTweet.slice(-6) : listIdTweet;
            let dataId = [...check];
            res?.data.map((item) => {
                data.push({
                    data: item,
                    id: item.tweetId,
                    count: 0,
                });
                dataId.push(item.tweetId);
            });
            if (page == 1) {
                // setTimeNow(data[0]?.data?.createdAt || Date.now())
                setTimeNow(Date.now());
            }
            setListIdTweet(dataId);
            setConutTweet(countTweet + 1);
            if ((page == 1 && res?.data.length < 4) || (page != 1 && res?.data.length < 20)) {
                setCheckLoadmoreNewTweet(false);
            }
            return data;
        }
        catch (_err) {
            return [];
        }
    };
    const callApiNewArticles = async (data) => {
        try {
            let res = null;
            let timeOneNewArticles = dataListArticles[0]?.dataNewArticles[0]?.posting_datetime || 0;
            let time = data == 1 ? false : (0, moment_1.default)(timeOneNewArticles).format('YYYY-MM-DD HH:mm:ss');
            let timeOneNewFollow = dataUser?.registration_status != 0 ?
                (dataListArticles[0]?.dataNewArticlesFollow[0]?.posting_datetime || 0) : 0;
            let timeFollow = data == 1 ? false : (0, moment_1.default)(timeOneNewFollow).format('YYYY-MM-DD HH:mm:ss');
            if (checkLoadmoreNewArticles) {
                res = await Home_1.default.NewArticles(1, data, time);
            }
            let resFollow = null;
            if (dataUser?.registration_status != 0 && checkLoadmoreNewArticlesFollow) {
                resFollow = await Home_1.default.NewArticlesFollow(1, data, timeFollow);
            }
            let resDataFirebase = null;
            if (data == 1) {
                resDataFirebase = await callApiListTweet(countTweet, 4);
            }
            else {
                resDataFirebase = await callApiListTweet(countTweet, 20);
            }
            setDataCallApi([
                {
                    dataFirebase: resDataFirebase,
                    dataNewArticles: res?.data?.data || null,
                    dataNewArticlesFollow: resFollow?.data?.data || null,
                },
            ]);
            if (res?.data?.total < countPageNewArticles * 5) {
                setCheckLoadmoreNewArticles(false);
            }
            if (resFollow?.data?.total < data * 5) {
                setCheckLoadmoreNewArticlesFollow(false);
            }
        }
        catch (error) {
            setReloadPage(false);
        }
        finally {
            setLoading(false);
            setCheckLoadMore(false);
        }
    };
    const reloadScreen = () => {
        setTimeNow(Date.now());
        setReloadPage(true);
        setConutTweet(1);
        setCountPageNewArticles(1);
        callApiNewArticles(1);
    };
    const handleLoadMore = () => {
        setCheckLoadMore(true);
        if (checkLoadMore ||
            (!checkLoadmoreNewTweet && !checkLoadmoreNewArticlesFollow && !checkLoadmoreNewArticles)) {
            setCheckLoadMore(false);
            return false;
        }
        else {
            setCheckLoadmore(true);
            setCountPageNewArticles(countPageNewArticles + 1);
            callApiNewArticles(countPageNewArticles + 1);
        }
        return false;
    };
    if (!connected) {
        return react_1.default.createElement(DisconnectScreen_1.DisconnectScreen, null);
    }
    const listData = [...dataListArticles];
    if (listData?.[0]) {
        listData[0].newTweet = newTweet;
    }
    return (react_1.default.createElement(react_native_1.View, { style: { backgroundColor: '#F7F7F7', flex: 1 } },
        react_1.default.createElement(header_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: 'center' }, titleStyle: {
                alignSelf: 'center',
                paddingRight: (0, scale_1.scale)(20),
            }, title: '', styleContainer: {
                backgroundColor: 'white',
            }, leftIcon: react_1.default.createElement(Hamburger_1.default, null), onLeftPress: () => {
                setVisibleMenu(true);
            } }),
        loading ? (react_1.default.createElement(skeletons_1.PostSkeleton, null)) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_native_1.FlatList, { contentContainerStyle: {
                    marginTop: (0, scale_1.scale)(5),
                    paddingBottom: (0, scale_1.scale)(50),
                }, showsVerticalScrollIndicator: false, data: listData, renderItem: (item) => (react_1.default.createElement(ItemLoop_1.default, { data: item.item, displayTweet: (data) => displayTweet(data) })), refreshing: reloadPage, onRefresh: reloadScreen, onEndReachedThreshold: 0.1, onEndReached: handleLoadMore, keyExtractor: (_item, index) => index.toString() }),
            checkLoadmore ? (react_1.default.createElement(react_native_1.View, { style: {
                    position: 'absolute',
                    width: '100%',
                    bottom: (0, scale_1.scale)(0),
                } },
                react_1.default.createElement(react_native_1.ActivityIndicator, { size: "small", color: '#286D84' }))) : null)),
        react_1.default.createElement(ModalMenu_1.default, { visible: visibleMenu, onClose: () => setVisibleMenu(false) })));
};
exports.default = HomeScreen;
